/**
 * @file DealDeadline.tsx
 * @description Срок сделки в строке реестра и на карточке доски (phase19.31,
 * макет (в)): просрочка — янтарный текст со значком «▲ 12 дн» и подписью
 * «до 20.09»; срок ещё не наступил — «до 20.09» и «осталось 3 дн»; срока
 * нет — прочерк. Тон и тексты — `dealDeadline` (lib/crm-deal-view).
 */

import { TriangleAlert } from "lucide-react";

import { TwoLineCell } from "../../ui/TwoLineCell";
import type { DealDto } from "../../../lib/api-crm";
import { dealDeadline } from "../../../lib/crm-deal-view";

type DeadlineInput = Pick<DealDto, "slaDeadlineAt" | "closedAt" | "currentStageKind">;

/** Янтарная пометка просрочки: значок + «12 дн». */
export function OverdueMark({ text }: { text: string }) {
  return (
    <span className="inline-flex items-center gap-1 tabular-nums text-[var(--status-attention-fg)]">
      <TriangleAlert aria-hidden className="size-3.5 shrink-0" />
      <span>
        <span className="sr-only">Просрочено на </span>
        {text}
      </span>
    </span>
  );
}

/** Ячейка «Срок» таблицы. */
export function DealDeadlineCell({ deal }: { deal: DeadlineInput }) {
  const state = dealDeadline(deal);
  if (state.kind === "none") return <span className="text-on-surface-variant">—</span>;
  if (state.kind === "overdue") {
    return <TwoLineCell primary={<OverdueMark text={state.overdue} />} secondary={state.until} />;
  }
  return <TwoLineCell primary={<span className="tabular-nums">{state.until}</span>} secondary={`осталось ${state.left}`} />;
}
